import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGridIconLargeInactive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={100.03}
    height={56.267}
    data-name="Group 169"
    {...props}
  >
    <g data-name="White Box">
      <path fill="#fff" d="M99.529 55.767H.499V.5h99.03Z" data-name="Path 1" />
      <path
        fill="#ccd3da"
        d="M1 1v54.267h98.03V1zM0 0h100.03v56.267H-.001Z"
        data-name="Path 2"
      />
    </g>
    <path
      fill="#ccd3da"
      d="M2.988 2.924h30.037v15.5H2.988Z"
      data-name="Grey Box"
    />
    <path
      fill="#ccd3da"
      d="M2.988 20.425h30.037v15.5H2.988Z"
      data-name="Grey Box-2"
    />
    <path
      fill="#ccd3da"
      d="M2.988 37.749h30.037v15.5H2.988Z"
      data-name="Grey Box-3"
    />
    <path
      fill="#ccd3da"
      d="M34.982 2.924h30.04v15.5h-30.04Z"
      data-name="Grey Box-4"
    />
    <path
      fill="#ccd3da"
      d="M34.982 20.425h30.04v15.5h-30.04Z"
      data-name="Grey Box-5"
    />
    <path
      fill="#ccd3da"
      d="M34.982 37.749h30.04v15.5h-30.04Z"
      data-name="Grey Box-6"
    />
    <path
      fill="#ccd3da"
      d="M66.982 2.925h30.037v15.5H66.982Z"
      data-name="Grey Box-7"
    />
    <path
      fill="#ccd3da"
      d="M66.982 20.426h30.037v15.5H66.982Z"
      data-name="Grey Box-8"
    />
    <path
      fill="#ccd3da"
      d="M66.982 37.75h30.037v15.5H66.982Z"
      data-name="Grey Box-9"
    />
  </svg>
);
export default SvgGridIconLargeInactive;
